export const animals = [
    {
     "id": "animal001",
     "commonName": "African Wild Dog",
     "scientificName": "Lycaon pictus",
     "speed": 45,
     "siteLink": "https:///en.wikipedia.org/wiki/African_wild_dog",
     "img": "/images/animals/wilddog.svg"
    },
    {
     "id": "animal002",
     "commonName": "American Cockroach",
     "scientificName": "Periplaneta americana",
     "speed": 3.4,
     "siteLink": "https:///en.wikipedia.org/wiki/American_cockroach",
     "img": "/images/animals/americancockroach.svg"
    },
    {
     "id": "animal003",
     "commonName": "Anna's Hummingbird",
     "scientificName": "Calypte anna",
     "speed": 61.06,
     "siteLink": "https:///en.wikipedia.org/wiki/Anna%27s_hummingbird",
     "img": "/images/animals/annahummingbird.svg"
    },
    {
     "id": "animal004",
     "commonName": "Atlantic Bluefin Tuna",
     "scientificName": "Thunnus thynnus",
     "speed": 43.51,
     "siteLink": "https:///en.wikipedia.org/wiki/Atlantic_bluefin_tuna",
     "img": "/images/animals/bluefin.svg"
    },
    {
     "id": "animal005",
     "commonName": "Bald Eagle",
     "scientificName": "Haliaeetus leucocephalus",
     "speed": 99,
     "siteLink": "https:///en.wikipedia.org/wiki/Bald_eagle",
     "img": "/images/animals/baldeagle.svg"
    },
    {
     "id": "animal006",
     "commonName": "Big Brown Bat",
     "scientificName": "Eptesicus fuscus",
     "speed": 40,
     "siteLink": "https:///en.wikipedia.org/wiki/Big_brown_bat",
     "img": "/images/animals/bigbrownbat.svg"
    },
    {
     "id": "animal007",
     "commonName": "Bison",
     "scientificName": "Bison",
     "speed": 35,
     "siteLink": "https:///en.wikipedia.org/wiki/Bison",
     "img": "/images/animals/bison.svg"
    },
    {
     "id": "animal008",
     "commonName": "Black Mamba Snake",
     "scientificName": "Dendroaspis polylepis",
     "speed": 12.9,
     "siteLink": "https:///en.wikipedia.org/wiki/Black_mamba",
     "img": "/images/animals/blackmamba.svg"
    },
    {
     "id": "animal009",
     "commonName": "Black Marlin",
     "scientificName": "Istiompax indica",
     "speed": 82,
     "siteLink": "https:///en.wikipedia.org/wiki/Black_marlin",
     "img": "/images/animals/blackmarlin.svg"
    },
    {
     "id": "animal010",
     "commonName": "Black Rhinoceros",
     "scientificName": "Diceros bicornis",
     "speed": 34,
     "siteLink": "https:///en.wikipedia.org/wiki/Black_rhinoceros",
     "img": "/images/animals/blackrhinoceros.svg"
    },
    {
     "id": "animal011",
     "commonName": "Blue Jay",
     "scientificName": "Cyanocitta cristata",
     "speed": 25,
     "siteLink": "https:///en.wikipedia.org/wiki/Blue_jay",
     "img": "/images/animals/bluejay.svg"
    },
    {
     "id": "animal012",
     "commonName": "Blue Shark",
     "scientificName": "Prionace glauca",
     "speed": 42.88,
     "siteLink": "https:///en.wikipedia.org/wiki/Blue_shark",
     "img": "/images/animals/blueshark.svg"
    },
    {
     "id": "animal013",
     "commonName": "Box Jellyfish",
     "scientificName": "Carukia barnesi",
     "speed": 4.6,
     "siteLink": "https:///en.wikipedia.org/wiki/Box_jellyfish",
     "img": "/images/animals/boxjellyfish.svg"
    },
    {
     "id": "animal014",
     "commonName": "Brown Bear",
     "scientificName": "Ursus arctos",
     "speed": 21.7,
     "siteLink": "https:///en.wikipedia.org/wiki/Brown_bear",
     "img": "/images/animals/brownbear.svg"
    },
    {
     "id": "animal015",
     "commonName": "Brown Rat",
     "scientificName": "Rattus norvegicus",
     "speed": 8,
     "siteLink": "https:///en.wikipedia.org/wiki/Brown_rat",
     "img": "/images/animals/brownrat.svg"
    },
    {
     "id": "animal016",
     "commonName": "Brown-Throated Sloth",
     "scientificName": "Aptenodytes forsteri",
     "speed": 0.15,
     "siteLink": "https:///en.wikipedia.org/wiki/Brown-throated_sloth",
     "img": "/images/animals/sloth.svg"
    },
    {
     "id": "animal017",
     "commonName": "Bumblebee",
     "scientificName": "Bombus",
     "speed": 33.6,
     "siteLink": "https:///en.wikipedia.org/wiki/Bumblebee",
     "img": "/images/animals/bumblebee.svg"
    },
    {
     "id": "animal018",
     "commonName": "Camel",
     "scientificName": "Camelus",
     "speed": 40,
     "siteLink": "https:///en.wikipedia.org/wiki/Camel",
     "img": "/images/animals/camel.svg"
    },
    {
     "id": "animal019",
     "commonName": "Canada Goose",
     "scientificName": "Branta canadensis",
     "speed": 60,
     "siteLink": "https:///en.wikipedia.org/wiki/Canada_goose",
     "img": "/images/animals/goose.svg"
    },
    {
     "id": "animal020",
     "commonName": "Capybera",
     "scientificName": "Hydrochoerus hydrochaeris",
     "speed": 21,
     "siteLink": "https:///en.wikipedia.org/wiki/Capybara",
     "img": "/images/animals/capybera.svg"
    },
    {
     "id": "animal021",
     "commonName": "Carpenter Ant",
     "scientificName": "Camponotus",
     "speed": 0.0005,
     "siteLink": "https:///en.wikipedia.org/wiki/Carpenter_ant",
     "img": "/images/animals/ant.svg"
    },
    {
     "id": "animal022",
     "commonName": "Cat (Domestic)",
     "scientificName": "Felis catus",
     "speed": 30,
     "siteLink": "https:///en.wikipedia.org/wiki/Cat",
     "img": "/images/animals/cat.svg"
    },
    {
     "id": "animal023",
     "commonName": "Cheetah",
     "scientificName": "Acinonyx jubatus",
     "speed": 74.6,
     "siteLink": "https:///en.wikipedia.org/wiki/Cheetah",
     "img": "/images/animals/cheetah.svg"
    },
    {
     "id": "animal024",
     "commonName": "Chicken",
     "scientificName": "Gallus gallus domesticus",
     "speed": 9,
     "siteLink": "https:///en.wikipedia.org/wiki/Chicken",
     "img": "/images/animals/chicken.svg"
    },
    {
     "id": "animal025",
     "commonName": "Common Dolphin",
     "scientificName": "Delphinus delphis",
     "speed": 37,
     "siteLink": "https:///en.wikipedia.org/wiki/Common_dolphin",
     "img": "/images/animals/commondolphin.svg"
    },
    {
     "id": "animal026",
     "commonName": "Common Ostrich",
     "scientificName": "Struthio camelus",
     "speed": 43.5,
     "siteLink": "https:///en.wikipedia.org/wiki/Common_ostrich",
     "img": "/images/animals/commonostrich.svg"
    },
    {
     "id": "animal027",
     "commonName": "Common Warthog",
     "scientificName": "Phacochoerus africanus",
     "speed": 30,
     "siteLink": "https:///en.wikipedia.org/wiki/Common_warthog",
     "img": "/images/animals/warthog.svg"
    },
    {
     "id": "animal028",
     "commonName": "Common Wombat",
     "scientificName": "Vombatidae",
     "speed": 25,
     "siteLink": "https:///en.wikipedia.org/wiki/Common_wombat",
     "img": "/images/animals/commonwombat.svg"
    },
    {
     "id": "animal029",
     "commonName": "Cottontail Rabbit",
     "scientificName": "Oryctolagus cuniculus",
     "speed": 35,
     "siteLink": "https:///en.wikipedia.org/wiki/European_rabbit",
     "img": "/images/animals/cottontailrabbit.svg"
    },
    {
     "id": "animal030",
     "commonName": "Cow",
     "scientificName": "Bos taurus",
     "speed": 25,
     "siteLink": "https:///en.wikipedia.org/wiki/Cattle",
     "img": "/images/animals/cow.svg"
    },
    {
     "id": "animal031",
     "commonName": "Coyote",
     "scientificName": "Canis latrans",
     "speed": 43,
     "siteLink": "https:///en.wikipedia.org/wiki/Coyote",
     "img": "/images/animals/coyote.svg"
    },
    {
     "id": "animal032",
     "commonName": "Eastern Gray Squirrel",
     "scientificName": "Sciurus carolinensis",
     "speed": 12.4,
     "siteLink": "https:///en.wikipedia.org/wiki/Eastern_gray_squirrel",
     "img": "/images/animals/squirrel.svg"
    },
    {
     "id": "animal033",
     "commonName": "Elephant",
     "scientificName": "Loxodonta",
     "speed": 24.9,
     "siteLink": "https:///en.wikipedia.org/wiki/African_elephant",
     "img": "/images/animals/elephant.svg"
    },
    {
     "id": "animal034",
     "commonName": "Emperor Penguin",
     "scientificName": "Aptenodytes forsteri",
     "speed": 5.6,
     "siteLink": "https:///en.wikipedia.org/wiki/Emperor_penguin",
     "img": "/images/animals/empirepenguin.svg"
    },
    {
     "id": "animal035",
     "commonName": "Flying Fish",
     "scientificName": "Exocoetidae",
     "speed": 34.8,
     "siteLink": "https:///en.wikipedia.org/wiki/Flying_fish",
     "img": "/images/animals/flyingfish.svg"
    },
    {
     "id": "animal036",
     "commonName": "Galapagos Tortoise",
     "scientificName": "Chelonoidis nigra",
     "speed": 0.2,
     "siteLink": "https:///en.wikipedia.org/wiki/Gal%C3%A1pagos_tortoise",
     "img": "/images/animals/galapagostortoise.svg"
    },
    {
     "id": "animal037",
     "commonName": "Garden Snail",
     "scientificName": "Cornu aspersum",
     "speed": 0.03,
     "siteLink": "https:///en.wikipedia.org/wiki/Cornu_aspersum",
     "img": "/images/animals/snail.svg"
    },
    {
     "id": "animal038",
     "commonName": "Ghost Crab",
     "scientificName": "Ocypodinae",
     "speed": 10,
     "siteLink": "https:///en.wikipedia.org/wiki/Ghost_crab",
     "img": "/images/animals/ghostcrab.svg"
    },
    {
     "id": "animal039",
     "commonName": "Giant House Spider",
     "scientificName": "Eratigena atrica",
     "speed": 1.2,
     "siteLink": "https:///en.wikipedia.org/wiki/Giant_house_spider",
     "img": "/images/animals/gianthousespider.svg"
    },
    {
     "id": "animal040",
     "commonName": "Giraffe",
     "scientificName": "Giraffa",
     "speed": 32.3,
     "siteLink": "https:///en.wikipedia.org/wiki/Giraffe",
     "img": "/images/animals/giraffe.svg"
    },
    {
     "id": "animal041",
     "commonName": "Golden Eagle",
     "scientificName": "Aquila chrysaetos",
     "speed": 200,
     "siteLink": "https:///en.wikipedia.org/wiki/Golden_eagle",
     "img": "/images/animals/goldeneagle.svg"
    },
    {
     "id": "animal042",
     "commonName": "Gray Fox",
     "scientificName": "Urocyon cinereoargenteus",
     "speed": 42,
     "siteLink": "https:///en.wikipedia.org/wiki/Gray_fox",
     "img": "/images/animals/grayfox.svg"
    },
    {
     "id": "animal043",
     "commonName": "Great White Shark",
     "scientificName": "Carcharodon carcharias",
     "speed": 35,
     "siteLink": "https:///en.wikipedia.org/wiki/Great_white_shark",
     "img": "/images/animals/greatwhiteshark.svg"
    },
    {
     "id": "animal044",
     "commonName": "Green Iguana",
     "scientificName": "Iguana iguana",
     "speed": 21,
     "siteLink": "https:///en.wikipedia.org/wiki/Green_iguana",
     "img": "/images/animals/greeniguana.svg"
    },
    {
     "id": "animal045",
     "commonName": "Greyhound",
     "scientificName": "Canis lupus familiaris",
     "speed": 45,
     "siteLink": "https:///en.wikipedia.org/wiki/Greyhound",
     "img": "/images/animals/greyhound.svg"
    },
    {
     "id": "animal046",
     "commonName": "Gyrfalcon",
     "scientificName": "Falco rusticolus",
     "speed": 130,
     "siteLink": "https:///en.wikipedia.org/wiki/Gyrfalcon",
     "img": "/images/animals/gyrfalcon.svg"
    },
    {
     "id": "animal047",
     "commonName": "Hippopotamus",
     "scientificName": "Hippopotamus amphibius",
     "speed": 19,
     "siteLink": "https:///en.wikipedia.org/wiki/Hippopotamus",
     "img": "/images/animals/hippopotamus.svg"
    },
    {
     "id": "animal048",
     "commonName": "Homing Pigeon",
     "scientificName": "Columba livia domestica",
     "speed": 95,
     "siteLink": "https:///en.wikipedia.org/wiki/Homing_pigeon",
     "img": "/images/animals/homingpigeon.svg"
    },
    {
     "id": "animal049",
     "commonName": "Honey Badger",
     "scientificName": "Mellivora capensis",
     "speed": 19,
     "siteLink": "https:///en.wikipedia.org/wiki/Honey_badger",
     "img": "/images/animals/honeybadger.svg"
    },
    {
     "id": "animal050",
     "commonName": "Horse",
     "scientificName": "Equus ferus caballus",
     "speed": 54.7,
     "siteLink": "https:///en.wikipedia.org/wiki/Horse",
     "img": "/images/animals/horse.svg"
    },
    {
     "id": "animal051",
     "commonName": "House Mouse",
     "scientificName": "Mus musculus",
     "speed": 8.1,
     "siteLink": "https:///en.wikipedia.org/wiki/House_mouse",
     "img": "/images/animals/housemouse.svg"
    },
    {
     "id": "animal052",
     "commonName": "Human",
     "scientificName": "Homo sapien",
     "speed": 27.9,
     "siteLink": "https:///en.wikipedia.org/wiki/Early_modern_human",
     "img": "/images/animals/human.svg"
    },
    {
     "id": "animal053",
     "commonName": "Killer Whale",
     "scientificName": "Orcinus orca",
     "speed": 35,
     "siteLink": "https:///en.wikipedia.org/wiki/Killer_whale",
     "img": "/images/animals/killerwhale.svg"
    },
    {
     "id": "animal054",
     "commonName": "Koala",
     "scientificName": "Phascolarctos cinereus",
     "speed": 18.6,
     "siteLink": "https:///en.wikipedia.org/wiki/Koala",
     "img": "/images/animals/koala.svg"
    },
    {
     "id": "animal055",
     "commonName": "Komodo Dragon",
     "scientificName": "Varanus komodoensis",
     "speed": 13,
     "siteLink": "https:///en.wikipedia.org/wiki/Komodo_dragon",
     "img": "/images/animals/komododragon.svg"
    },
    {
     "id": "animal056",
     "commonName": "Leatherback Sea Turtle",
     "scientificName": "Dermochelys coriacea",
     "speed": 21.9,
     "siteLink": "https:///en.wikipedia.org/wiki/Leatherback_sea_turtle",
     "img": "/images/animals/leatherbackseaturtle.svg"
    },
    {
     "id": "animal057",
     "commonName": "Leopard",
     "scientificName": "Panthera pardus",
     "speed": 36,
     "siteLink": "https:///en.wikipedia.org/wiki/Leopard",
     "img": "/images/animals/leopard.svg"
    },
    {
     "id": "animal058",
     "commonName": "Leopard Tortoise",
     "scientificName": "Stigmochelys pardalis",
     "speed": 0.62,
     "siteLink": "https:///en.wikipedia.org/wiki/Leopard_tortoise",
     "img": "/images/animals/tortoise.svg"
    },
    {
     "id": "animal059",
     "commonName": "Lion",
     "scientificName": "Panthera leo",
     "speed": 49.7,
     "siteLink": "https:///en.wikipedia.org/wiki/Lion",
     "img": "/images/animals/lion.svg"
    },
    {
     "id": "animal076",
     "commonName": "Mako Shark",
     "scientificName": "Isurus oxyrinchus",
     "speed": 45,
     "siteLink": "https:///en.wikipedia.org/wiki/Shortfin_mako_shark",
     "img": "/images/animals/makoshark.svg"
    },
    {
     "id": "animal060",
     "commonName": "Mexican Free-Tailed Bat",
     "scientificName": "Tadarida brasiliensis",
     "speed": 60,
     "siteLink": "https:///en.wikipedia.org/wiki/Mexican_free-tailed_bat",
     "img": "/images/animals/mexicanbat.svg"
    },
    {
     "id": "animal061",
     "commonName": "Monarch Butterfly",
     "scientificName": "Danaus plexippus",
     "speed": 6,
     "siteLink": "https:///en.wikipedia.org/wiki/Monarch_butterfly",
     "img": "/images/animals/monarchbutterfly.svg"
    },
    {
     "id": "animal062",
     "commonName": "Moose",
     "scientificName": "Alces alces",
     "speed": 35,
     "siteLink": "https:///en.wikipedia.org/wiki/Moose",
     "img": "/images/animals/moose.svg"
    },
    {
     "id": "animal063",
     "commonName": "Nauta Salamander",
     "scientificName": "Bolitoglossa altamazonica",
     "speed": 15,
     "siteLink": "https:///en.wikipedia.org/wiki/Nauta_salamander",
     "img": "/images/animals/nautasalamander.svg"
    },
    {
     "id": "animal064",
     "commonName": "Pangolin",
     "scientificName": "Pholidota",
     "speed": 3.1,
     "siteLink": "https:///en.wikipedia.org/wiki/Pangolin",
     "img": "/images/animals/pangolin.svg"
    },
    {
     "id": "animal065",
     "commonName": "Pelican",
     "scientificName": "Pelecanus onocrotalus",
     "speed": 30,
     "siteLink": "https:///en.wikipedia.org/wiki/Pelican",
     "img": "/images/animals/pelican.svg"
    },
    {
     "id": "animal066",
     "commonName": "Peregrine Falcon",
     "scientificName": "Falco peregrinus",
     "speed": 242,
     "siteLink": "https:///en.wikipedia.org/wiki/Peregrine_falcon",
     "img": "/images/animals/falcon.svg"
    },
    {
     "id": "animal067",
     "commonName": "Perentie",
     "scientificName": "Varanus giganteus",
     "speed": 25,
     "siteLink": "https:///en.wikipedia.org/wiki/Perentie",
     "img": "/images/animals/perentie.svg"
    },
    {
     "id": "animal068",
     "commonName": "Pig",
     "scientificName": "Sus domesticus",
     "speed": 11,
     "siteLink": "https:///en.wikipedia.org/wiki/Pig",
     "img": "/images/animals/pig.svg"
    },
    {
     "id": "animal069",
     "commonName": "Plains Zebra",
     "scientificName": "Equus quagga",
     "speed": 40,
     "siteLink": "https:///en.wikipedia.org/wiki/Plains_zebra",
     "img": "/images/animals/zebra.svg"
    },
    {
     "id": "animal070",
     "commonName": "Polar Bear",
     "scientificName": "Ursus maritimus",
     "speed": 25,
     "siteLink": "https:///en.wikipedia.org/wiki/Polar_bear",
     "img": "/images/animals/polarbear.svg"
    },
    {
     "id": "animal071",
     "commonName": "Pronghorn",
     "scientificName": "Antilocapra americana",
     "speed": 61,
     "siteLink": "https:///en.wikipedia.org/wiki/Pronghorn",
     "img": "/images/animals/pronghorn.svg"
    },
    {
     "id": "animal072",
     "commonName": "Red Kangaroo",
     "scientificName": "Macropus rufus",
     "speed": 43.5,
     "siteLink": "https:///en.wikipedia.org/wiki/Red_kangaroo",
     "img": "/images/animals/kangaroo.svg"
    },
    {
     "id": "animal073",
     "commonName": "Reindeer",
     "scientificName": "Rangifer tarandus",
     "speed": 50,
     "siteLink": "https:///en.wikipedia.org/wiki/Reindeer",
     "img": "/images/animals/reindeer.svg"
    },
    {
     "id": "animal074",
     "commonName": "Roadrunner",
     "scientificName": "Geococcyx californianus",
     "speed": 19.9,
     "siteLink": "https:///en.wikipedia.org/wiki/Greater_roadrunner",
     "img": "/images/animals/roadrunner.svg"
    },
    {
     "id": "animal075",
     "commonName": "Saltwater Crocodile",
     "scientificName": "Crocodylus porosus",
     "speed": 18,
     "siteLink": "https:///en.wikipedia.org/wiki/Saltwater_crocodile",
     "img": "/images/animals/saltwatercrocodile.svg"
    },
    {
     "id": "animal077",
     "commonName": "Sidewinder",
     "scientificName": "Crotalus cerastes",
     "speed": 18,
     "siteLink": "https:///en.wikipedia.org/wiki/Crotalus_cerastes",
     "img": "/images/animals/sidewinder.svg"
    },
    {
     "id": "animal078",
     "commonName": "Six-Lined Racerunner",
     "scientificName": "Aspidoscelis sexlineata",
     "speed": 18,
     "siteLink": "https:///en.wikipedia.org/wiki/Six-lined_racerunner",
     "img": "/images/animals/racerunner.svg"
    },
    {
     "id": "animal079",
     "commonName": "Spotted Hyena",
     "scientificName": "Crocuta crocuta",
     "speed": 39.8,
     "siteLink": "https:///en.wikipedia.org/wiki/Spotted_hyena",
     "img": "/images/animals/spottedhyena.svg"
    },
    {
     "id": "animal080",
     "commonName": "Swordfish",
     "scientificName": "Xiphias gladius",
     "speed": 62.1,
     "siteLink": "https:///en.wikipedia.org/wiki/Swordfish",
     "img": "/images/animals/swordfish.svg"
    },
    {
     "id": "animal081",
     "commonName": "Tasmanian Devil",
     "scientificName": "Sarcophilus harrisii",
     "speed": 8.1,
     "siteLink": "https:///en.wikipedia.org/wiki/Tasmanian_devil",
     "img": "/images/animals/tasmanian.svg"
    },
    {
     "id": "animal082",
     "commonName": "Thomson'S Gazelle",
     "scientificName": "Eudorcas thomsonii",
     "speed": 40.4,
     "siteLink": "https:///en.wikipedia.org/wiki/Thomson's_gazelle",
     "img": "/images/animals/thomsonsgazelle.svg"
    },
    {
     "id": "animal083",
     "commonName": "Tiger",
     "scientificName": "Panthera tigris",
     "speed": 40,
     "siteLink": "https:///en.wikipedia.org/wiki/Tiger",
     "img": "/images/animals/tiger.svg"
    },
    {
     "id": "animal084",
     "commonName": "Tiger Beetle",
     "scientificName": "Cicindelinae",
     "speed": 5,
     "siteLink": "https:///en.wikipedia.org/wiki/Tiger_beetle",
     "img": "/images/animals/tigerbeetle.svg"
    },
    {
     "id": "animal085",
     "commonName": "White-Tailed Deer",
     "scientificName": "Odocoileus virginianus",
     "speed": 30,
     "siteLink": "https:///en.wikipedia.org/wiki/White-tailed_deer",
     "img": "/images/animals/whitetaileddeer.svg"
    },
    {
     "id": "animal086",
     "commonName": "Wildebeest",
     "scientificName": "Connochaetes",
     "speed": 39.8,
     "siteLink": "https:///en.wikipedia.org/wiki/Wildebeest",
     "img": "/images/animals/wildebeest.svg"
    }
   ];
